module.exports = __WEBPACK_EXTERNAL_MODULE_18__;


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 18
// module chunks = 21 22